import React, { useState } from 'react';
import { StyledContainer } from './index.styles';
import { FormErrors, RegistrationRabenSchema } from './form';
import { PageState } from './types';
import Header from './components/Header';
import RegistrationFirstPage from './RegistrationFirstPage';
import RegistrationSecondPage from './RegistrationSecondPage';
import { ReportingFreq } from 'src/utils/api.interfaces';
import { Typography } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SomethingWentWrong from 'src/components/SomethingWentWrong';
import { useSupplierSurveyRaben } from 'src/Ghg/SupplierSurvey/hooks';
import RegistrationTarget from './components/RegistrationTarget';

export default function RegisterRaben() {
  const { token } = useParams();
  // the environment and branch this link registers into (same endpoint the
  // survey intro of the link reads)
  const { data: linkTarget } = useSupplierSurveyRaben();

  const [searchParams, _] = useSearchParams();
  const vatIdentifier = searchParams.get('vat_identifier') ?? '';
  const organizationName = searchParams.get('organization_name') ?? '';
  const email = searchParams.get('email') ?? '';
  const reportingPeriod = searchParams.get('reporting_period') ?? undefined;

  const { t } = useTranslation(undefined, { keyPrefix: 'registration_raben' });

  const [form, setForm] = useState<RegistrationRabenSchema>({
    token: token || '',
    first_name: '',
    last_name: '',
    email,
    phone_number: '',
    organization_name: organizationName,
    vat_identifier: vatIdentifier,
    reporting_period: reportingPeriod,
    country: '',
    password: '',
    reporting_frequency: ReportingFreq.M,
    terms_of_service_consent: false,
  });
  const [pageState, setPageState] = useState<PageState>(
    'registration-first-page'
  );
  const [errors, setErrors] = useState<FormErrors>({});

  const onNextPage = () => {
    setPageState('registration-second-page');
    window.scrollTo(0, 0);
  };

  const onPreviousPage = () => {
    setPageState('registration-first-page');
    window.scrollTo(0, 0);
  };

  if (!token) {
    return <SomethingWentWrong />;
  }

  return (
    <StyledContainer>
      <Header />
      <RegistrationTarget
        target={linkTarget}
        sx={{ alignSelf: 'stretch', mx: '10px', mb: '32px' }}
      />
      <form style={{ marginLeft: '10px', marginRight: '10px' }}>
        <Typography variant="h5" sx={{ mb: '20px' }}>
          {t('subsubtitle')}
        </Typography>
        {pageState === 'registration-first-page' && (
          <RegistrationFirstPage
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            onNext={onNextPage}
          />
        )}
        {pageState === 'registration-second-page' && (
          <RegistrationSecondPage
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            onPrevious={onPreviousPage}
          />
        )}
      </form>
    </StyledContainer>
  );
}
